/**
 * 蛍光ペン。
 *
 * 本文は読み飛ばされる前提で組む。拾ってほしい語だけ下半分を塗って、
 * 目が滑っても数語は残るようにする。
 *
 * 塗るのは短い語だけ。1行まるごと塗ると、塗っていないのと同じになる。
 * 鉤括弧の中は括弧自体が強調なので重ねない。
 * 色は差し色1つ。濃度 26% は、太字の黒が沈まないぎりぎり。
 *
 * 濃い地の上では同じ濃度だと沈むので tone="dark" を渡す。
 * 塗りを上げて、字も白へ起こす。地が黒いと薄い緑は「汚れ」に見える。
 *
 * box-decoration-break: clone は、折り返した2行目にも塗りを続けるため。
 * 付けないと2行目が塗られない。
 */
export function Mark({
  children,
  tone = "light",
}: {
  children: React.ReactNode;
  tone?: "light" | "dark";
}) {
  const alpha = tone === "dark" ? "42%" : "26%";

  return (
    <span
      className={`font-bold [-webkit-box-decoration-break:clone] [box-decoration-break:clone] ${
        tone === "dark" ? "text-white" : ""
      }`}
      style={{
        backgroundImage: `linear-gradient(transparent 58%, color-mix(in srgb, var(--color-shegate-accent) ${alpha}, transparent) 58%)`,
      }}
    >
      {children}
    </span>
  );
}
